import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MfkInformation, MfkValidator, MfkService, MerchantAccount, MerchantAccountType } from '../../../shared';
import { Mfk, MfkFieldOption, MfkFieldName } from '@uiowa/uiowa-mfk';

@Component({
    selector: 'app-mfk-information',
    templateUrl: './mfk-information.component.html'
})
export class MfkInformationComponent implements OnInit {

    @Input() formGroupName: string;
    @Input() showErrors: boolean;

    mfkInformation: MfkInformation;
    mfkInformationFormGroup: FormGroup;
    get depositMfk(): AbstractControl {
        return this.mfkInformationFormGroup.get('depositMfk');
    }
    get chargebackMfk(): AbstractControl {
        return this.mfkInformationFormGroup.get('chargebackMfk');
    }
    isCashnet: boolean;
    depositMfkOptions: MfkFieldOption[] = [];
    chargebackMfkOptions = [new MfkFieldOption(MfkFieldName.IACT, "6405", true)];

    constructor(
        private readonly rootFormGroup: FormGroupDirective,
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly mfkService: MfkService
    ) {
    }

    ngOnInit() {
        this.route.data.subscribe(({ merchantAccount }: { merchantAccount: MerchantAccount }) => {
            var mfkInformationToUse : MfkInformation = {
                chargebackMfk : this.setMfkValue(merchantAccount.mfkInformation.chargebackMfk),
                depositMfk : this.setMfkValue(merchantAccount.mfkInformation.depositMfk)
            } 

            this.isCashnet = merchantAccount.merchantAccountType === MerchantAccountType.Cashnet;
            this.mfkInformation = mfkInformationToUse;
            this.mfkInformationFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
            if (!this.isCashnet) {
                this.depositMfkOptions = [...this.depositMfkOptions, new MfkFieldOption(MfkFieldName.IACT, "4598", true)];
            }
            var depositMfkValidators = this.isCashnet ? [MfkValidator.fieldLengths(), MfkValidator.validateCashnetDepositIacct()] : [MfkValidator.fieldLengths()];
            this.mfkInformationFormGroup.addControl("depositMfk", this.fb.control(this.mfkInformation.depositMfk, depositMfkValidators, [MfkValidator.validate(this.mfkService)]));
            this.mfkInformationFormGroup.addControl("chargebackMfk", this.fb.control(this.mfkInformation.chargebackMfk, [MfkValidator.fieldLengths()], [MfkValidator.validate(this.mfkService)]));
        });
    }

    onDepositMfkChange(mfk: Mfk): void {
        this.depositMfk.setValue(mfk);
        this.depositMfk.updateValueAndValidity();
    }

    onChargebackMfkChange(mfk: Mfk): void {
        this.chargebackMfk.setValue(mfk);
        this.chargebackMfk.updateValueAndValidity();
    }

    //interrogate MFK values, setting null to blank strings so MFK input does not break
    private setMfkValue(mfk: Mfk): Mfk
    {
        var mfkValue = mfk;
        mfkValue.fund = mfkValue.fund ? mfkValue.fund : '';
        mfkValue.org = mfkValue.org ? mfkValue.org : '';
        mfkValue.dept = mfkValue.fund ? mfkValue.dept : '';
        mfkValue.subdept = mfkValue.subdept ? mfkValue.subdept : '';
        mfkValue.grantpgm = mfkValue.grantpgm ? mfkValue.grantpgm : '';
        mfkValue.iact = mfkValue.iact ? mfkValue.iact : '';
        mfkValue.oact = mfkValue.oact ? mfkValue.oact : ''; 
        mfkValue.dact = mfkValue.dact ? mfkValue.dact : '';
        mfkValue.fn = mfkValue.fn ? mfkValue.fn : '';
        mfkValue.cctr = mfkValue.cctr ? mfkValue.cctr : '';
        mfkValue.brf = mfkValue.brf ? mfkValue.brf : '';

        return mfkValue;
    }
}